export const LogInIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1 8.2h-8M8 5.7l2.5 2.5L8 10.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.1 10.7v1.25a1.25 1.25 0 001.25 1.25h5a1.25 1.25 0 001.25-1.25v-7.5a1.25 1.25 0 00-1.25-1.25H7.6c-.69 0-1.5.56-1.5 1.25V5.7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
